module.exports = __webpack_public_path__ + "static/media/button_appear.b2514227.mp3";